import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionComponent } from './subscription.component';
import { SharedModule } from '@app/core/shared/shared.module';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';

const routes: Routes = [
  // {
  //   path: '',
  //   component: SubscriptionComponent,
  // },
];

@NgModule({
  declarations: [SubscriptionComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    NgxGoogleAnalyticsModule,
  ],
  exports: [SubscriptionComponent],
})
export class SubscriptionModule {}
